/* Recent searches — records search terms in localStorage and shows the last few
   when an empty search box is focused. Self-contained: it inserts its own panel
   directly after the search form (in normal flow, below the input) so it never
   fights the predictive-search results. Hidden as soon as the user types. */
(function () {
  var KEY = 'lsc_recent_searches';
  var MAX = 6;
  var panel = null;

  function read() {
    try { var v = JSON.parse(window.localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function record(term) {
    term = (term || '').trim();
    if (!term) return;
    var list = read().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    if (list.length > MAX) list = list.slice(0, MAX);
    write(list);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function hide() { if (panel) { panel.remove(); panel = null; } }

  function show(input) {
    hide();
    var list = read();
    if (!list.length) return;
    var form = input.closest('form');
    if (!form) return;
    panel = document.createElement('div');
    panel.className = 'recent-searches';
    panel.innerHTML =
      '<div class="recent-searches__head">' +
      '<span class="recent-searches__heading">Recent searches</span>' +
      '<button type="button" class="recent-searches__clear">Clear</button></div>' +
      '<ul class="recent-searches__list">' +
      list.map(function (t) {
        return '<li><button type="button" class="recent-searches__item">' + esc(t) + '</button></li>';
      }).join('') +
      '</ul>';
    form.insertAdjacentElement('afterend', panel);
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); }); // keep input focus
    // The panel sits inside <predictive-search>, whose onKeyup preventDefault()s
    // every keyup — which cancelled Space activating a panel button. Keep panel
    // keyups from reaching it so Space (and Enter) fire their native click.
    panel.addEventListener('keyup', function (e) { e.stopPropagation(); });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('.recent-searches__clear')) { write([]); hide(); return; }
      var b = e.target.closest('.recent-searches__item');
      if (!b) return;
      input.value = b.textContent;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      hide();
      input.focus();
    });
  }

  // record on search submit (Enter / search button)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.querySelector && (f.getAttribute('action') || '').indexOf('/search') !== -1) {
      var inp = f.querySelector('input[type="search"]');
      if (inp) record(inp.value);
    }
  }, true);

  // Only the real product search boxes get the panel — NOT the country/currency
  // selector's filter (also input[type=search], but in the localization form).
  function isSearchInput(inp) {
    var f = inp.closest && inp.closest('form');
    if (f && (f.getAttribute('action') || '').indexOf('/search') !== -1) return true;
    return !!(inp.closest && inp.closest('predictive-search, search-form'));
  }

  document.addEventListener('focusin', function (e) {
    var inp = e.target;
    if (inp && inp.matches && inp.matches('input[type="search"]') && !inp.value.trim() && isSearchInput(inp)) show(inp);
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('input[type="search"]') && e.target.value.trim()) hide();
  });
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      if (!panel) return;
      // Keep the panel while focus is anywhere in its own form (the input, or the
      // submit/reset buttons Tab lands on) so Tab can reach the panel's items.
      var form = panel.previousElementSibling;
      if (!panel.contains(document.activeElement) && !(form && form.contains(document.activeElement))) hide();
    }, 150);
  });

  // Keyboard access: ArrowDown from the input enters the panel; arrows move within
  // it; Escape closes and returns focus to the input. (Enter/Space activate the
  // item buttons natively.)
  document.addEventListener('keydown', function (e) {
    if (!panel) return;
    var items = [].slice.call(panel.querySelectorAll('.recent-searches__item'));
    if (!items.length) return;
    var searchInput = panel.previousElementSibling && panel.previousElementSibling.querySelector('input[type="search"]');
    if (e.target.matches && e.target.matches('input[type="search"]')) {
      if (e.key === 'ArrowDown') { e.preventDefault(); items[0].focus(); }
      return;
    }
    var idx = items.indexOf(document.activeElement);
    if (idx === -1) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(idx + 1, items.length - 1)].focus(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); if (idx === 0 && searchInput) searchInput.focus(); else items[idx - 1].focus(); }
    else if (e.key === 'Escape') { hide(); if (searchInput) searchInput.focus(); }
  });
})();
